import React, { useState } from 'react';
import api from '../utils/api';
import { useToast } from '../context/ToastContext';

const UNITS = ['PCS','Sets','KG','MT','Pcs','Bags','Rolls','Cartons'];
const blank = () => ({ date: new Date().toISOString().split('T')[0], name:'', goods:'', hs_code:'', cusdec_no:'', qty:'', units:'PCS', new_wt:'', value_usd:'', liability:'' });

export default function AddTiepPage() {
  const toast = useToast();
  const [form, setForm] = useState(blank());
  const [saving, setSaving] = useState(false);

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSave = async () => {
    const req = ['date','name','goods','hs_code','cusdec_no','qty','units','value_usd','liability'];
    if (req.some(k => !form[k])) { toast('Please fill all required fields', 'error'); return; }
    setSaving(true);
    try {
      const { data } = await api.post('/tiep_goods/create.php', { ...form, qty: +form.qty, new_wt: +form.new_wt||0, value_usd: +form.value_usd, liability: +form.liability });
      if (data.success) { toast('TIEP entry saved!'); setForm(blank()); }
      else toast(data.error || 'Save failed', 'error');
    } catch { toast('Network error', 'error'); }
    finally { setSaving(false); }
  };

  const perUnit = form.qty && form.liability ? (form.liability / form.qty).toFixed(4) : null;

  return (
    <div>
      <div className="page-header">
        <div><div className="page-title">Add TIEP Goods</div><div className="page-sub">Register imported raw materials under TIEP guarantee</div></div>
      </div>
      <div className="page-body">
        <div style={{ maxWidth:900 }}>
          <div className="alert alert-info" style={{ marginBottom:18 }}>ℹ️ All fields marked * are required. CUSDEC No is used for issuing goods and MUD forms.</div>
          <div className="card">
            <div className="card-header"><span className="card-title">✚ TIEP Entry Details</span></div>
            <div className="card-body">
              <div className="form-grid cols-3">
                {[
                  { k:'date',      l:'Date *',              t:'date' },
                  { k:'name',      l:'Supplier Name *',     p:'e.g. Egesun' },
                  { k:'goods',     l:'Goods Description *', p:'e.g. Lids TSB 63 Gold' },
                  { k:'hs_code',   l:'HS Code *',           p:'e.g. 83099090' },
                  { k:'cusdec_no', l:'CUSDEC No *',         p:'e.g. S 21905' },
                  { k:'qty',       l:'Quantity *',          t:'number', p:'e.g. 23040' },
                ].map(({k,l,t,p}) => (
                  <div className="form-group" key={k}>
                    <label className="lbl">{l}</label>
                    <input className="input" type={t||'text'} value={form[k]} onChange={set(k)} placeholder={p} />
                  </div>
                ))}

                <div className="form-group">
                  <label className="lbl">Units *</label>
                  <select className="input" value={form.units} onChange={set('units')}>
                    {UNITS.map(u => <option key={u}>{u}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="lbl">New Weight (kg)</label>
                  <input className="input" type="number" step="0.01" value={form.new_wt} onChange={set('new_wt')} placeholder="e.g. 8741.04" />
                </div>
                <div className="form-group">
                  <label className="lbl">Value (LKR) *</label>
                  <input className="input" type="number" step="0.01" value={form.value_usd} onChange={set('value_usd')} placeholder="e.g. 4423321.00" />
                </div>
                <div className="form-group">
                  <label className="lbl">Liability (LKR) *</label>
                  <input className="input" type="number" step="0.01" value={form.liability} onChange={set('liability')} placeholder="e.g. 1455474.00" />
                </div>
              </div>

              {perUnit && (
                <div style={{ marginTop:16, background:'var(--light)', borderRadius:8, padding:'12px 16px', display:'flex', gap:24, fontSize:13 }}>
                  <div><span style={{ color:'var(--text2)' }}>Liability per unit: </span><strong style={{ color:'var(--teal)' }}>LKR {perUnit}</strong></div>
                  {form.value_usd && <div><span style={{ color:'var(--text2)' }}>Value per unit: </span><strong style={{ color:'var(--teal)' }}>LKR {(form.value_usd/form.qty).toFixed(4)}</strong></div>}
                </div>
              )}

              <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:20, paddingTop:16, borderTop:'1px solid var(--border)' }}>
                <button className="btn btn-secondary" onClick={() => setForm(blank())}>Clear</button>
                <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                  {saving ? '…' : '✓ Save TIEP Entry'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
